module.exports = __webpack_public_path__ + "img/Avatar_color.bfee36ec.svg";